import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Row, Col, Form, FormInput, Button, Text } from 'shared/components'
import { dateWithTime } from 'constants/dateFormats'

import * as style from './styles'

const InWinFiltersComponent = ({ form, exportToExcel }) => (
  <Form form={form}>
    <Grid>
      <Row css={style.filtersWrapper}>
        <Col xs={12} sm={6} md={5} lg={3}>
          <FormInput
            fluid
            name="dateFrom"
            type="date"
            showTimeInput
            showYearDropdown
            dateFormat={dateWithTime}
            placeholder="Date from"
            css={style.phoneSpace}
            oldInput
          />
        </Col>
        <Col xs={12} sm={6} md={5} lg={3}>
          <FormInput
            fluid
            name="dateTo"
            type="date"
            showTimeInput
            showYearDropdown
            dateFormat={dateWithTime}
            placeholder="Date to"
            css={style.phoneSpace}
            oldInput
          />
        </Col>
        <Col xs={12} sm={3} md={3} lg={2}>
          <Button
            medium
            green
            onClick={() => exportToExcel(form)}
            css={[style.wrapButton, style.phoneSpace]}
          >
            <Text size={11}>Export to Excel</Text>
          </Button>
        </Col>
      </Row>
    </Grid>
  </Form>
)

InWinFiltersComponent.propTypes = {
  form: PropTypes.shape().isRequired,
  getOptionLabel: PropTypes.func,
  getOptionValue: PropTypes.func,
  loadCategories: PropTypes.func,
  loadSubcategories: PropTypes.func,
  exportToExcel: PropTypes.func.isRequired,
}

export default InWinFiltersComponent
